import React, { useEffect, useState } from "react";
import api, { STAGE_LABELS } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { TrendingUp, FolderKanban, CheckCircle2, Clock, AlertTriangle, Users, FileText, Bell, Mail, IndianRupee, DollarSign, ArrowUp, ArrowDown, BarChart3 } from "lucide-react";
import { toast } from "sonner";
import SurveydraftsActivityPanel from "@/components/dashboard/SurveydraftsActivityPanel";
import EmployeeDashboard from "@/pages/EmployeeDashboard";

export const StatCard = ({ label, value, icon: Icon, accent, testid }) => (
  <div className="brut-card p-5" data-testid={testid}>
    <div className="flex items-start justify-between">
      <div>
        <div className="label-mono">{label}</div>
        <div className="font-heading text-4xl font-black mt-1">{value}</div>
      </div>
      <div className={`w-10 h-10 border border-zinc-900 flex items-center justify-center ${accent || "bg-yellow-200"}`}>
        <Icon className="w-5 h-5" strokeWidth={2.25} />
      </div>
    </div>
  </div>
);

export const MiniStat = ({ label, value, delta, icon: Icon, accent, testid, isMoney }) => (
  <div className="border border-zinc-900 p-3 flex items-start justify-between" data-testid={testid}>
    <div className="min-w-0">
      <div className="label-mono">{label}</div>
      <div className={`font-heading font-black mt-1 ${isMoney ? "text-xl" : "text-3xl"}`}>{value}</div>
      {typeof delta === "number" && delta !== 0 && (
        <div className={`text-[10px] font-mono mt-1 flex items-center gap-0.5 ${delta > 0 ? "text-green-700" : "text-red-700"}`}>
          {delta > 0 ? <ArrowUp className="w-3 h-3" /> : <ArrowDown className="w-3 h-3" />}
          {Math.abs(delta)} vs last month
        </div>
      )}
    </div>
    <div className={`w-8 h-8 border border-zinc-900 flex items-center justify-center shrink-0 ${accent || "bg-yellow-200"}`}>
      <Icon className="w-4 h-4" strokeWidth={2.25} />
    </div>
  </div>
);

export function Kpi({ label, value, testid }) {
  return (
    <div className="border border-zinc-900 p-3" data-testid={testid}>
      <div className="label-mono">{label}</div>
      <div className="font-heading text-2xl font-black mt-1">{value}</div>
    </div>
  );
}

// ----------------------------- Weekly Digest tile -----------------------------
export function KpiLine({ label, value, good, bad }) {
  return (
    <div className="flex justify-between border-b border-zinc-100 py-1">
      <span className="text-zinc-500 truncate mr-2">{label}</span>
      <span className={`font-bold whitespace-nowrap ${good ? "text-green-700" : bad ? "text-red-700" : ""}`}>{value}</span>
    </div>
  );
}

// ----------------------------- Stale jobs -----------------------------
